<h3 class="ppb-section-title"
    i18n="@@business-partner.business_partner"
>Partner Biznesowy</h3>
<div *ngIf="isPartnerSectionActive(); else noPartners">
  <span class="ppb-section-text"
        i18n="@@business-partner.select_partner"
  >Wybierz Partnera Biznesowego, dla którego chcesz uruchomić aplikację</span>
  <select (change)="this.onChange($event.target.value)" class="o-form-select u-width-500">
    <option *ngFor="let item of partnersDashboards"
            [value]="item.partnerCode"
            [selected]="isSelected(item)">
      {{item.partnerName}}
    </option>
  </select>
</div>
<ng-template #noPartners>
  <span class="ppb-section-text"
        i18n="@@business-partner.no_grants_to_partners"
  >Nie posiadasz uprawnień dostępowych dla żadnego Partnera Biznesowego.</span>
</ng-template>

<h3 class="ppb-section-title"
    i18n="@@dashboard.apps"
>Aplikacje</h3>
<div *ngIf="isApplicationSectionActive(); else noApplications">
  <span class="ppb-section-text"
        i18n="@@dashboard.no_apps"
  >Aplikacje dostępne dla Partnera Biznesowego</span>
  <div class="applications-list">
    <div *ngFor="let app of selectedPartner.boardDtoList">
      <div *ngIf="app.name"
           [id]="getId(app)" class="tile"
           [pseiTooltip]="isApplicationDisabled(app) ? tooltipText : ''"
           [ngClass]="{'disabled': isApplicationDisabled(app)}"
           (click)="exchangeSecretForUuid(app)"
      >
      </div>
    </div>
  </div>
</div>
<ng-template #noApplications>
  <span class="ppb-section-text"
        i18n="@@dashboard.no_grants_to_apps"
  >Nie masz dostępu do żadnej aplikacji</span>
</ng-template>
